
import React, { useState, useEffect } from "react";
import { formatDateToYYYY_MM_DD } from "../../Utils/DateUtils";
import GetDistricts from "../../Dropdowns/getAllDistrictsWithSelect";
import GetAllAfso from "../../Dropdowns/getAllAfsoWithSelect";
import GetFpssIdAll from "../../Dropdowns/getFpsidAll";
import Distribution_extension from "./Distribution_extension";
import Distribution_Office_Extend from "./Distribution_Office_Extend";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import progressGif from "../../images/progress.gif";

const Distribution_Extend_Interface = ({ heading, username }) => {
  const getTodayDate = (yearFromApi = null, monthFromApi = null) => {
    const today = new Date();
    const year = yearFromApi || today.getFullYear();
    const month = String(monthFromApi || today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };



  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/MaximunVersion-EndDate`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.date) {
          setSelectedDate(convertToInputDate(data.date));
        }
      })
      .catch((err) => console.error("Error fetching initial date:", err));
  }, []);

  const [selectedDate, setSelectedDate] = useState("");
  const [selectedDistCode, setSelectedDistCode] = useState("");
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [maxVersionDateformApi, setMaxVersionDateformApi] = useState("");
  const [yearFromApi, setYearFromApi] = useState("");
  const [monthFromApi, setMonthFromApi] = useState("");
  const [userRole, setUserRole] = useState(null);
  const [userName, setuserName] = useState(null);
  const [sessionExpired, setSessionExpired] = useState(false);
  const [renderContent, setRenderContent] = useState(null);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [loading, setLoading] = useState(true); // Manage loading state

  const [loadingFpsId, setLoadingFpsId] = useState(false);
  const [selectedAfso, setSelectedAfso] = useState("");
  const [selectedFpsId, setselectedFpsId] = useState("");

  const [loadingAfso, setLoadingAfso] = useState(false);

  // Utility: Convert DD-MM-YYYY → YYYY-MM-DD
  const convertToInputDate = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateStr;
  };

  //  Utility: Format to DD-MM-YYYY (always correct)
  const formatDateToDD_MM_YY = (date) => {
    if (!date) return "";

    let d;
    if (typeof date === "string") {
      if (date.includes("-")) {
        const parts = date.split("-");
        if (parts[0].length === 4) {
          // YYYY-MM-DD → normal
          d = new Date(`${parts[0]}-${parts[1]}-${parts[2]}`);
        } else {
          // DD-MM-YYYY → reverse to normal
          d = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
        }
      } else {
        d = new Date(date);
      }
    } else {
      d = new Date(date);
    }

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear(); // full year (YYYY)
    return `${day}-${month}-${year}`;
  };

  //  Set min/max date = today → next 15 days
  useEffect(() => {
    const today = new Date();
    const maxDate = new Date();
    maxDate.setDate(today.getDate() + 15);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    setMinDate(formatDate(today));
    setMaxDate(formatDate(maxDate));
  }, []);

  const navigate = useNavigate();

  //  Fetch session info
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL}/api/session-info`, { withCredentials: true })
      .then((res) => {
        setUserRole(res.data.userRole);
        setuserName(res.data.userName);
        //if (res.data.userRole !== "1") navigate("/login");
      })
      .catch(() => {
        setSessionExpired(true);
      });
  }, [navigate]);

  //  Fetch month==is stored in year varable
  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/currentYear`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.year) setYearFromApi(data.year);
      })
      .catch((err) => console.error("Error fetching year:", err));
  }, []);

  //  Fetch month
  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/currentMonth`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.year) setMonthFromApi(data.year);
      })
      .catch((err) => console.error("Error fetching month:", err));
  }, []);

  //  Fetch max version date
  useEffect(() => {
    if (!selectedDistCode) return;

    // fetch(`${process.env.REACT_APP_URL}/api/version-date`)
    fetch(
      `${process.env.REACT_APP_URL}/api/version-date?dist_code=${selectedDistCode}`
    )

      .then((res) => res.json())
      .then((data) => {
        if (data?.date) {
          setMaxVersionDateformApi(data.date);
          console.log("Version date from API:", data.date);
          const converted = convertToInputDate(data.date);
          setSelectedDate(converted);
        }
      })
      .catch((err) => console.error("Error fetching version date:", err));
  }, [selectedDistCode]);


  const handleDistrictChange = (dist_code) => {
    setSelectedDistCode(dist_code); 

    setSelectedAfso("");
  setselectedFpsId("");

  };

  const handleLoadingChange = (isLoading) => {
    setLoading(isLoading);
  };

  const handleAfsoChange = (afso_code) => {
    setSelectedAfso(afso_code);
      setselectedFpsId("");

  };

  const handleFpsChange = (fps_id) => {
    setselectedFpsId(fps_id);
  };

  //  Distribution Extension Submit
  const handleSubmit = () => {
    if (!monthFromApi) return alert("Please select a month before submitting.");
    if (!yearFromApi) return alert("Please select a year before submitting.");
    if (!selectedDistCode || selectedDistCode === "") return alert("Please select a district before submitting.");
    if (!selectedAfso || selectedAfso === "") return alert(" Please select a office before submitting ");
    if (!selectedFpsId || selectedFpsId === "") return alert(" Please select a fps_id before submitting ");
    if (!selectedDate) return alert("Please select a valid date.");


    const formatted_date = formatDateToYYYY_MM_DD(selectedDate);
    const chosenDate = new Date(selectedDate);
    const maxVersion = new Date(convertToInputDate(maxVersionDateformApi));

    console.log("Chosen Date:", chosenDate);
    console.log("Max Version Date (API):", maxVersion);

    // if (chosenDate > maxVersion) {
    //   alert(
    //     `Selected date ${formatDateToDD_MM_YY(chosenDate)} cannot be greater than allowed version date ${formatDateToDD_MM_YY(maxVersionDateformApi)}.`
    //   );
    //   return false;
    // }

    //  Clear & render Distribution component
    setRenderContent(null);
    setTimeout(() => {
      setRenderContent(
        <Distribution_extension
          district={selectedDistCode}
          office_id={selectedAfso}
          fps_id={selectedFpsId}
          heading={heading}
          year={yearFromApi}
          month={monthFromApi}
          trans_date={formatted_date}

        />
      );
    }, 0);


  // ✅ RESET states after submit
  setSelectedAfso("");
  setselectedFpsId("");
  };

  const handleSubmitTso = () => {
    if (!monthFromApi) return alert("Please select a month before submitting.");
    if (!yearFromApi) return alert("Please select a year before submitting.");
    if (!selectedDistCode || selectedDistCode === "")
      return alert("Please select a district before submitting.");
    if (!selectedDate) return alert("Please select a valid date.");

    const formatted_date = formatDateToYYYY_MM_DD(selectedDate);
    const chosenDate = new Date(selectedDate);
    const maxVersion = new Date(convertToInputDate(maxVersionDateformApi));

    console.log("Chosen Date:", chosenDate);
    console.log("Max Version Date (API):", maxVersion);

    // if (chosenDate > maxVersion) {
    //   alert(
    //     `${formatDateToDD_MM_YY(chosenDate)} is greater than ${formatDateToDD_MM_YY(maxVersionDateformApi)}`
    //   );
    //   return false;
    // }

    setRenderContent(null);
    setTimeout(() => {
      setRenderContent(
        <Distribution_Office_Extend
          trans_date={formatted_date}
          dist_code={selectedDistCode}
          heading={heading}
          year={yearFromApi}
          month={monthFromApi}
          office_id={selectedAfso}
          fps_id={selectedFpsId}
        />
      );
    }, 0);
  };

  //  Date access rule
  const today = new Date();
  const day = today.getDate();
  console.log(day + ">>>>>day");
  const isAllowed = (day > 0 && day <= 31) || userName?.toLowerCase() === "admin";

  // if (userRole !== "1" ) {
  //   return <div>Session expired or unauthorized. Please login again.</div>;
  // }

  return (
    <div className="wrapper row3">
      <div id="container">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <table width="60%" border="1" cellPadding="6">
            <thead>
              <tr className="tableheader">
                <th colSpan={12}>Distribution Extension</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>District</td>
                <td>
                  <GetDistricts
                    onLoadingChange={setLoadingDistricts}
                    onChange={handleDistrictChange}
                  />
                </td>
                <td>AFSO</td>
                <td>
                  {selectedDistCode ? (
                    <GetAllAfso
                      dist_code={selectedDistCode}
                      onLoadingChange={setLoadingAfso}
                      onChange={handleAfsoChange}
                    />
                  ) : (
                    <select disabled>
                      <option value=""></option>
                    </select>
                  )}
                </td>

                <td>FPS</td>
                <td>
                  {selectedAfso ? (

                    <GetFpssIdAll
                      dist_code={selectedDistCode}
                      afso_code={selectedAfso}
                      onLoadingChange={setLoadingFpsId}
                      onChange={handleFpsChange}
                    />

                  ) : (
                    <select disabled>
                      <option value=""></option>
                    </select>
                  )}
                </td>
                <td>Month</td>
                <td>{monthFromApi}</td>
                <td>Year</td>
                <td>{yearFromApi}</td>
                <td>Up To</td>
                <td>
                  <input
                    type="date"
                    name="version_date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    onKeyDown={(e) => e.preventDefault()}
                    min={minDate}
                    max={maxDate}
                  />
                  <input type="hidden" name="cur_date" value={getTodayDate()} />
                </td>
              </tr>

              <tr>
                <td colSpan={12} align="center">
                  {isAllowed ? (
                    <>
                      <button onClick={handleSubmit} className="button button2">
                        Submit
                      </button>
                      <button onClick={handleSubmitTso} className="button button2">
                        Show
                      </button>
                      <button
                        className="button button2"
                        onClick={() => window.history.back()}
                      >
                        Back
                      </button>
                    </>
                  ) : (
                    <div className="mainhead">
                      Distribution Extension Screen enabled between 25th to 31st of the Month
                    </div>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {renderContent}

        {loadingDistricts && (
          <div style={{ textAlign: "center" }} align="center">
            <img src={progressGif} alt="Loading..." />
          </div>
        )}
      </div>
    </div>
  );

};

export default Distribution_Extend_Interface;